import { GlobalConstants } from "../../data/GlobalConstants";
import { handleResponse } from "../../util/functions";
import { getToken } from "../../helpers/helperJWT";
import { loaderService } from "../loaderService";

const url = GlobalConstants.urlApi;

const getUsuarios = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/usuarios/getUsuarios`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getFullUser = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/usuarios/getFullUser`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getListasByNegocio = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/usuarios/getListasByNegocio`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getPuntosdeVentaUsuario = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/usuarios/getPuntosdeVentaUsuario`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updatePasswordUsuario = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/usuarios/updatePasswordUsuario`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateListaUsuario = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/usuarios/updateListaUsuario`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updatePuntosVentaUsuario = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/usuarios/updatePuntosVentaUsuario`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getUserProfile = (data) => {
    loaderService.showLoader({ label: "Cargando..." });
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/usuarios/getUserProfile`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}
//error
const updateUserProfile = (data) => {
    loaderService.showLoader({ label: "Cargando..." });
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/usuarios/updateUserProfile`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        }
        );
}

const VerifyInfo = (data) => {
    loaderService.showLoader({ label: "Cargando..." });
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/usuarios/VerifyInfo`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}
export const usuariosService = {
    getUsuarios,
    getFullUser,
    getListasByNegocio,
    updatePasswordUsuario,
    updateListaUsuario,
    getPuntosdeVentaUsuario,
    updatePuntosVentaUsuario,
    getUserProfile,
    updateUserProfile,
    VerifyInfo

};
